import devChangeEmployeeComponent from './devChangeEmployee.component';

let devChangeEmployeeModule = angular.module('components.devChangeEmployee', [])

.component('devChangeEmployee', devChangeEmployeeComponent)

.name;

export default devChangeEmployeeModule;



// WEBPACK FOOTER //
// ./client/app/features/mainRouting/index/devChangeEmployee/devChangeEmployee.js